import { selector } from 'recoil';
import { businessFlowSelector } from './getBusinessFlowSelector';
import { allCoverablesAtom } from '../atoms/allCoverablesAtom';
import { allCoverablesToCoverableDTOArray } from '../../utils/coverablesUtil';

export const hideInfoInMpsSelector = selector({
    key: 'hideInfoInMpsSelector',
    get: ({ get }) => {
        const isMps = get(businessFlowSelector) === 'MPS';
        const coverables = get(allCoverablesAtom);
        return isMps && allCoverablesToCoverableDTOArray(coverables).length === 0;
    }
});
